module.exports = __webpack_public_path__ + "media/images/athletes/1773-1bfdbc78488d7112bb9a23d2ef527c01.png";